// extracted by mini-css-extract-plugin
export default {"link":"styles-module__link__src-labstep-web-components-File-Preview-_cKNdi","span":"styles-module__span__src-labstep-web-components-File-Preview-_eoXMe"};